export default (...parts) => `/${parts.filter(url => url).join('/')}`;
